import { render, staticRenderFns } from "./Sv2Score.vue?vue&type=template&id=167ed812&scoped=true&"
import script from "./Sv2Score.vue?vue&type=script&lang=js&"
export * from "./Sv2Score.vue?vue&type=script&lang=js&"
import style0 from "./Sv2Score.vue?vue&type=style&index=0&id=167ed812&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ed812",
  null
  
)

export default component.exports